import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    loading: false,
    data:''
} 

export const CompanyReducer = createSlice({
    name: 'CompanyReducer',
    initialState,
    reducers: {
        initiateLoading: (state) => {
          state.loading = true
         },
        addSuccess: (state, action) => {
           state.loading = false;
          state.data = action.payload;
        },
        addFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
        resetData:(state,action)=>{
            state.loading = false;
            state.data = ''; 
        }
    }
});

export const { addSuccess, addFailure,initiateLoading,resetData} = CompanyReducer.actions;

// Selectors
export const getCompanyReducer = (state) => {
    return state.CompanyReducer;
};

export default CompanyReducer.reducer;
